import { Paragraph } from '@zillow/constellation-10';

import { useGetListingDetails } from '../../../../../hooks/queries/properties';
import { useFeedPhotoUploadLock } from '../../../../../hooks/useFeedPhotoUploadLock';
import { useReimportLock } from '../../../../../hooks/useReimportLock';

import type { FeedPhotoUploadScope } from '../../../../../hooks/useFeedPhotoUploadLock';

type Props = {
  listingAlias: string;
  scope: FeedPhotoUploadScope;
};

// Building photos sit under the Building media section's syncing banner, but floor plan photos are in a modal that
// covers it, so only floor plans explain the reimport lock here.
const FeedPhotoUploadPausedMessage = ({ listingAlias, scope }: Props) => {
  const { data: listingDetails } = useGetListingDetails(listingAlias);
  const { isFeedPhotoUploadLocked } = useFeedPhotoUploadLock({ listingAlias, scope });
  const { isReimportLocked } = useReimportLock({ listingAlias });

  if (!(listingDetails?.isFeed ?? false)) {
    return null;
  }

  if (isFeedPhotoUploadLocked) {
    return (
      <Paragraph css={{ marginBottom: '400' }}>
        You recently uploaded an image. Photo changes are paused for less than a minute while it processes.
      </Paragraph>
    );
  }

  if (isReimportLocked && scope.type === 'floorPlan') {
    return (
      <Paragraph css={{ marginBottom: '400' }}>
        Photo uploads are paused while the listing syncs with the feed after overrides were turned off.
      </Paragraph>
    );
  }

  return null;
};

export default FeedPhotoUploadPausedMessage;
